module.exports = __webpack_public_path__ + "static/img/female-bg-es.138d7108.png";